import AuthStyle from './AuthStyle.module.css';
import { useEffect, useState } from "react";
import {responseMsg} from "../../common/ResponseMsg";
import useDevice from '../../../shared/hooks/useDevice';
import Card from '../../../shared/components/Card';
import Padding from '../../../shared/components/Padding';
import Flex from '../../../shared/components/Flex';
import Text from '../../../shared/components/Text';
import Input from '../../../shared/components/Input';
import Spacer from '../../../shared/components/Spacer';
import ModalButton from '../../../shared/components/ModalButton';
import { AgGridReact } from 'ag-grid-react';
import Switch from '../../../shared/components/Switch';
import { useAlert } from '../../../shared/components/AlertProvider';

function AuthEditModal({selectedRole, rendering}) {
    const [checkBox, setCheckBox] = useState([]);
    const device = useDevice();
    const isMobile = device !== 'desktop'
    const showAlert = useAlert();

    const checkBoxRenderer = (cell) => {
        const col = cell.colDef;
        const value = cell.data[col.field];

        return (
            <div style={{ display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center" }}>
                <Switch
                    checked={value}
                    onChange={(e) => checkBoxChangeHandler(cell, e)}
                />
            </div>
        )
    }

    const createMenusArr = (arr,menus) => {
        if (!menus) return;

        menus.forEach(ele => {
            arr.push(ele);
            createMenusArr(arr,ele.children);
        });
    }

    useEffect(() => {
        
        fetch("/api/system/menus",{
            method:"GET"
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    const menus = [];
                    createMenusArr(menus,json.data);

                    menus.forEach(ele => {
                        if (!ele.children.length) {
                            ele['modal_select'] = selectedRole?.menus.find(menu => menu.id === ele.id) ? true : false;
                            ele['modal_insert'] = selectedRole?.privileges.find(privilege => privilege.type === 'I' && privilege.menuId === ele.id) ? true : false;
                            ele['modal_update'] = selectedRole?.privileges.find(privilege => privilege.type === 'U' && privilege.menuId === ele.id) ? true : false;
                        } else {
                            ele['modal_select'] = null
                            ele['modal_insert'] = null
                            ele['modal_update'] = null
                        }
                    })

                    setCheckBox(menus);
            
                }  else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
    },[])

    const gridConfig = {
        columnDefs: [
            { headerName: 'Level', field: 'depth', flex: 1,},
            { headerName: '시스템명', field: 'name', flex: 1,},
            { headerName: 'URL', field: 'url', flex: 3,},
            { headerName: '조회', field: 'modal_select', cellRenderer: checkBoxRenderer, flex: 1,},
            { headerName: '등록', field: 'modal_insert', cellRenderer: checkBoxRenderer, flex: 1,},
            { headerName: '수정', field: 'modal_update', cellRenderer: checkBoxRenderer, flex: 1,},
        ],
        pagination: false,
        rowData: checkBox,
        suppressRowHoverHighlight: true,
    };

    const onUpdateHandler = () => {
        const reqCheckBox = [];

        checkBox.forEach(ele => {
            ele['modal_select'] && reqCheckBox.push({menuId:ele.id, roleId:selectedRole.id, type: 'S'})
            ele['modal_insert'] && reqCheckBox.push({menuId:ele.id, roleId:selectedRole.id, type: 'I'})
            ele['modal_update'] && reqCheckBox.push({menuId:ele.id, roleId:selectedRole.id, type: 'U'})
        })

        fetch("/api/system/roles",{
            method:"PATCH",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqCheckBox),
            })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "수정완료"});
                    rendering();
                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch(error => {
            });
    }

    const checkBoxChangeHandler = (cell,event) => {
        const isChecked = event.target.checked ? true : false;

        const newMenus = [...checkBox].map(ele => {
            if (ele.id === cell.data.id) {
                ele[cell.colDef.field] = isChecked;
            }

            return ele;
        })

        setCheckBox(newMenus);
    }

    return (
        <>
            <div>
                <Card fullWidth>
                    <Padding>
                        <Flex 
                            flexDirection={isMobile ? "column" : "row"}
                            gap={isMobile ? 8 : 30}
                        >   
                            <Flex alignItems='center'>
                                <Text size={"sm"} style={{textAlign:"center" ,width: "80px", flexShrink: 0}}>권한코드</Text>
                                <Input id='roleId' defaultValue={selectedRole.name} style={{flex: 1, backgroundColor: "#F5F7F9"}} fullWidth={isMobile} readOnly />
                            </Flex>
                            <Flex alignItems='center'>
                                <Text size={"sm"} style={{textAlign:"center" ,width: "80px", flexShrink: 0}}>권한명</Text>
                                <Input id='roleName' defaultValue={selectedRole.encodedNm} style={{flex: 1, backgroundColor: "#F5F7F9"}} maxLength={200} fullWidth={isMobile} readOnly/>
                            </Flex>
                            <Flex alignItems='center'>
                                <Text size={"sm"} style={{textAlign:"center" ,width: "80px", flexShrink: 0}}>비고</Text>
                                <Input id='roleRemark' defaultValue={selectedRole.comment} style={{flex: 1, backgroundColor: "#F5F7F9"}} maxLength={255} fullWidth={isMobile} readOnly/>
                                </Flex>
                            </Flex>
                    </Padding>
                </Card>

                <Spacer direction='vertical' size={25} />

                <div className={AuthStyle.right} style={{ flex:1, minWidth: 0, height: isMobile ? " 338px" : "422px"}}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <AgGridReact
                                rowData={checkBox}
                                columnDefs={gridConfig.columnDefs}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="end" gap={10}>
                <ModalButton type='update' onClick={onUpdateHandler} />
                {/* <ModalButton onClick={deleteData} /> */}
                <ModalButton type='cancel' onClick={rendering} />
            </Flex>
        </>
    );
}

export default AuthEditModal;